export default __webpack_public_path__ + "static/media/feedback-icon.0cebdfda.png";